import { call } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';

export function* onRestreamingStoppedSaga() {
  yield call(eventBus.sendMessage, 'restreamingStopped');
}
